export { IVirtualElement } from '@fluentui/dom-utilities';
